import { createAction } from 'redux-actions';
import * as actionTypes from './constants';

export const updateSort = createAction(actionTypes.UPDATE_USERS_SORT);
export const updateSearchString = createAction(actionTypes.UPDATE_SEARCH_STRING);
export const updateLatestAddedUsers = createAction(actionTypes.UPDATE_LATEST_ADDED_USERS);

// Add
export const addUser = createAction(actionTypes.ADD_USER_REQUEST);
export const addUserSuccess = createAction(actionTypes.ADD_USER_SUCCESS);
export const addUserFailure = createAction(actionTypes.ADD_USER_FAILURE);

// Delete
export const deleteUser = createAction(actionTypes.DELETE_USER_REQUEST);
export const deleteUserSuccess = createAction(actionTypes.DELETE_USER_SUCCESS);
export const deleteUserFailure = createAction(actionTypes.DELETE_USER_FAILURE);

// Update
export const updateUser = createAction(actionTypes.UPDATE_USER_REQUEST);
export const updateUserSuccess = createAction(actionTypes.UPDATE_USER_SUCCESS);
export const updateUserFailure = createAction(actionTypes.UPDATE_USER_FAILURE);

// Search
export const fetchUsers = createAction(actionTypes.FETCH_SCOPED_USERS_REQUEST);
export const fetchUsersSuccess = createAction(actionTypes.FETCH_SCOPED_USERS_SUCCESS);
export const fetchUsersFailure = createAction(actionTypes.FETCH_SCOPED_USERS_FAILURE);

// Search Next
export const fetchUsersNext = createAction(actionTypes.FETCH_SCOPED_USERS_NEXT_REQUEST);
export const fetchUsersNextSuccess = createAction(actionTypes.FETCH_SCOPED_USERS_NEXT_SUCCESS);
export const fetchUsersNextFailure = createAction(actionTypes.FETCH_SCOPED_USERS_NEXT_FAILURE);

// Permissions
export const fetchPermissions = createAction(actionTypes.GET_PERMISSIONS_REQUEST);
export const fetchPermissionsSuccess = createAction(actionTypes.GET_PERMISSIONS_SUCCESS);
export const fetchPermissionsFailure = createAction(actionTypes.GET_PERMISSIONS_FAILURE);
